<template>
  <div class="loginwarp">
    <div class="login-content">
      <h3 class="login-title">荧识 INSERV SCRM 应用管理平台</h3>
      <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" @keyup.enter.native="loginSubmit" size="small">
        <el-form-item prop="username">
          <el-input type="text" v-model.trim="loginForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model.trim="loginForm.password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="btnLoading" @click="loginSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import { Auth } from '@/model'
import Config from '../conf'
export default {
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginFormLoading: false,
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      },
      btnLoading: false
    }
  },
  methods: {
    async loginSubmit () {
      this.btnLoading = true
      let res = await Auth.login(this.loginForm)
      this.btnLoading = false
      if (res['err_code'] !== 0) {
        this.$message.error(res['err_msg'])
      } else {
        this.$cookie.set(Config['token_key'], res['data']['token'])
        this.$message({
          message: '登录成功！',
          type: 'success'
        })
        window.location.href = window.location.origin
      }
    }
  },
  created () {
    console.log(window.location)
  }
};
</script>

<style scoped>
.loginwarp {
  width: 100%;
  height: 100vh;
  position: relative;
}
.login-content {
  background-clip: padding-box;
  background-color: #f9fafc;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0,0,0,.35);
  margin-bottom: 20px;
  padding: 35px 35px 15px;
  width: 280px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -175px;
}
.login-title {
  color: #505458;
  margin: 0 auto 40px;
  text-align: center;
}
</style>